"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const material_1 = require("@mui/material");
const classnames_1 = require("classnames");
const merge_1 = require("merge");
const Label_styles_1 = require("../../components/Label/Label.styles");
const InputLabel = ({ label, htmlFor, hasError, children, style, inputContainerStyle, __unsafe__onClick, }) => {
    const [focused, setFocused] = (0, react_1.useState)(false);
    const { labelStyles, inputContainer, container } = (0, Label_styles_1.default)({ focused, hasError });
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, { onFocus: () => setFocused(true), onBlur: () => setFocused(false), sx: (0, merge_1.merge)(true, container, style), className: (0, classnames_1.default)({ hasError }), children: [(0, jsx_runtime_1.jsx)(material_1.Box, { onClick: __unsafe__onClick, component: "label", htmlFor: htmlFor, sx: labelStyles, children: label }), (0, jsx_runtime_1.jsx)(material_1.Box, { className: "inputContainer", sx: (0, merge_1.merge)(true, inputContainer, inputContainerStyle), children: children })] }));
};
exports.default = InputLabel;
